import { render, staticRenderFns } from "./CategoryProduct.vue?vue&type=template&id=02cccafa&scoped=true&"
import script from "./CategoryProduct.vue?vue&type=script&lang=js&"
export * from "./CategoryProduct.vue?vue&type=script&lang=js&"
import style0 from "./CategoryProduct.vue?vue&type=style&index=0&id=02cccafa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cccafa",
  null
  
)

export default component.exports